<template lang="pug">
  .dm
    div(v-if="!videoShown")
      img.thumb(:src='"http://www.dailymotion.com/thumbnail/video/"+link.url', @click="changeToVideo", @load="testLoadedImage", ref="img")
      i.fa.fa-play.fa-2x
    .videoWrapper(v-if="videoShown")
      iframe(:src='"//www.dailymotion.com/embed/video/"+link.url+"?autoplay=1"' frameborder="0" allowfullscreen)
</template>
<script>
export default {
  props: ['link'],
  data () {
    return {videoShown: false}
  },
  methods: {
    changeToVideo () {
      this.videoShown = true
    },
    tryNextResolution () {},
    testLoadedImage () {}
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageLinkDailymotion.vue?62a2806c